module.exports = "\r\n<sui-panel headerText=\"Form in Panel Sample\" panelClass=\"sui-card-12\">\r\n    <sui-form [fields]=\"fields\" (send)=\"save($event);\"> </sui-form>\r\n</sui-panel>";


//////////////////
// WEBPACK FOOTER
// ./src/app/samples/sample.form/sample.form.component.html
// module id = 418
// module chunks = 0